"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _CLabel = _interopRequireDefault(require("01_core/components/materials/CLabel"));
var _CodeUtil = require("01_core/components/system/CodeUtil");
var _CodeConsts = require("01_core/constants/CodeConsts");
var _labelConsts = require("01_core/constants/labelConsts");
var _stringConsts = require("01_core/constants/stringConsts");
var _stringUtil = _interopRequireDefault(require("01_core/logics/stringUtil"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _styles = require("@mui/material/styles");
var _KunrenInfoField = _interopRequireDefault(require("../../common/components/KunrenInfoField"));
var _Consts = require("../../common/consts/Consts");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const PreLineTypography = (0, _styles.styled)(_Typography.default)(_ref => {
  let {
    theme
  } = _ref;
  return {
    whiteSpace: 'pre-line',
    fontSize: theme.typography.body2.fontSize
  };
});
class ScenarioCommonDetail extends _react.default.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "targetRiskList", () => {
      const {
        guidanceEntry
      } = this.props;
      let targetRiskList = [];
      guidanceEntry.checkStatusList.forEach((item, index) => {
        if (item.guidelineCd === _Consts.CONSTS.GUIDELINE_OTHER) {
          if (item.checkKbn === _CodeConsts.CODE.BCM_KJ_DATA_KBN.CODE_01 && item.activityFlg === _CodeConsts.CODE.FLG_VALUE.CODE_1) {
            if (targetRiskList.length !== 0) {
              targetRiskList.push(_stringConsts.STRING_CONSTS.TOUTEN_ZENKAKU);
            }
            targetRiskList.push(item.notes);
          }
        } else {
          if (item.checkKbn === _CodeConsts.CODE.BCM_KJ_DATA_KBN.CODE_01 && item.activityFlg === _CodeConsts.CODE.FLG_VALUE.CODE_1) {
            if (targetRiskList.length !== 0) {
              targetRiskList.push(_stringConsts.STRING_CONSTS.TOUTEN_ZENKAKU);
            }
            targetRiskList.push(item.contents);
          }
        }
      });
      if (targetRiskList.length === 0) {
        targetRiskList.push(/*#__PURE__*/_react.default.createElement(_Typography.default, {
          variant: "body2"
        }, _stringConsts.STRING_CONSTS.HYPHEN_ZENKAKU));
      } else {
        targetRiskList = /*#__PURE__*/_react.default.createElement(_Typography.default, {
          variant: "body2"
        }, targetRiskList);
      }
      return targetRiskList;
    });
    _defineProperty(this, "kunrenPeriodList", () => {
      const {
        guidanceEntry
      } = this.props;
      let kunrenPeriodList = [];
      guidanceEntry.checkStatusList.forEach((item, index) => {
        if (item.checkKbn === _CodeConsts.CODE.BCM_KJ_DATA_KBN.CODE_02 && item.activityFlg === _CodeConsts.CODE.FLG_VALUE.CODE_1) {
          if (kunrenPeriodList.length !== 0) {
            kunrenPeriodList.push(_stringConsts.STRING_CONSTS.TOUTEN_ZENKAKU);
          }
          kunrenPeriodList.push(item.contents);
        }
      });
      if (kunrenPeriodList.length === 0) {
        kunrenPeriodList.push(/*#__PURE__*/_react.default.createElement(_Typography.default, {
          variant: "body2"
        }, _stringConsts.STRING_CONSTS.HYPHEN_ZENKAKU));
      } else {
        kunrenPeriodList = /*#__PURE__*/_react.default.createElement(_Typography.default, {
          variant: "body2"
        }, kunrenPeriodList);
      }
      return kunrenPeriodList;
    });
  }
  render() {
    const {
      intl,
      guidanceEntry,
      kunrenInfo,
      getCodeName,
      deleteFlg
    } = this.props;
    let message = '';
    if (guidanceEntry.regNecScenarioCheck || guidanceEntry.regBuScenarioCheck) {
      message = intl.formatMessage({
        id: _labelConsts.LABEL.BCM_SCENARIO_REGIST
      });
    } else {
      message = intl.formatMessage({
        id: _labelConsts.LABEL.BCM_SCENARIO_NOT_REGIST
      });
    }
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_KunrenInfoField.default, {
      data: kunrenInfo
    }), /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.BCM_BCP_JISSHI_POLICY
      }),
      indent: true
    }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.BCM_BCP_SCENARIO_POLICY
      }),
      indent: true
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body2"
    }, getCodeName(_CodeConsts.CODE.BCM_SCENARIO.KBN, guidanceEntry.scenarioPolicyCd)))), /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.BCM_KUNREN_REPORT_JISSHI_DETAIL
      }),
      indent: true
    }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.BCM_BCP_IMPLEMENTATION_YOTEI_ATE
      }),
      indent: true
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body2"
    }, guidanceEntry.exercisesDt)), /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.BCM_KUNREN_TGT_RISK
      }),
      indent: true
    }, this.targetRiskList()), /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.BCM_KUNREN_TGT_RISK_DETAIL
      }),
      indent: true
    }, /*#__PURE__*/_react.default.createElement(PreLineTypography, null, _stringUtil.default.emptyToHyphen(guidanceEntry.riskDetailNotes))), /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.BCM_KUNREN_PERIOD
      }),
      indent: true
    }, this.kunrenPeriodList()), /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.BCM_KUNREN_PURPOSE
      }),
      indent: true
    }, /*#__PURE__*/_react.default.createElement(PreLineTypography, null, _stringUtil.default.emptyToHyphen(guidanceEntry.kunrenPurpose))), /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.BCM_KUNREN_CONTENT
      }),
      indent: true
    }, /*#__PURE__*/_react.default.createElement(PreLineTypography, null, _stringUtil.default.emptyToHyphen(guidanceEntry.kunrenContent))), /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.BCM_KUNREN_SUPPLEMENT
      }),
      indent: true
    }, /*#__PURE__*/_react.default.createElement(PreLineTypography, null, _stringUtil.default.emptyToHyphen(guidanceEntry.supplement))), !deleteFlg && _CodeConsts.CODE.BCM_SCENARIO.CODE_03 === guidanceEntry.scenarioPolicyCd && /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.BCM_BCP_SCENARIO_REGISTER
      }),
      indent: true
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body2"
    }, " ", message, " "))));
  }
}
var _default = exports.default = (0, _CodeUtil.withCodeUtil)((0, _reactIntl.injectIntl)(ScenarioCommonDetail));